module.exports = __webpack_public_path__ + "static/media/params.1328bc33.png";